import { Box, Button } from '@mui/material'
import * as React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { runSubControl } from '../../store/HouseContainer/operations'
import { getSubControls } from '../../store/SubControlById/selectors'
import { Control, SubControl } from '../../types'

type Props = {
	control: Control
}

// ON/OFF 機器の手動制御。
// 方針:
// - 遠隔機器と状態がずれる可能性があるため、片方を無効化せず ON/OFF どちらも常に押せる。
// - トグル(選択UI)には見せない。独立した2つの操作ボタンとして扱う。
// - 現在(既知)の状態は control.isHit に一本化（行の緑ハイライトと一致）。
//   現在状態のボタンだけを塗りで「点灯」し、ON は緑・OFF は停止を表す濃いグレー。
//   もう片方はアウトライン（消灯）にして、OFF 中に ON へ見えないようにする。
const BoolMachineToogleButton = (props: Props) => {
	const subControls = useSelector((s) => getSubControls(s, props.control.id))
	const dispatch = useDispatch()

	const onControl = subControls.find((v) => v.rate === 100)
	const offControl = subControls.find((v) => v.rate === 0)

	const isOn = props.control.isHit

	const run = (sub: SubControl) => {
		if (!window.confirm('自動制御がオフになりますが実行しますか？')) return
		dispatch(runSubControl(sub))
	}

	return (
		<Box sx={{ display: 'flex', gap: 1 }}>
			{onControl && (
				<Button
					size="small"
					disableElevation
					variant={isOn ? 'contained' : 'outlined'}
					color={isOn ? 'success' : 'inherit'}
					onClick={() => run(onControl)}
					sx={{ minWidth: 52, fontWeight: 700 }}
				>
					ON
				</Button>
			)}
			{offControl && (
				<Button
					size="small"
					disableElevation
					variant={!isOn ? 'contained' : 'outlined'}
					color="inherit"
					onClick={() => run(offControl)}
					sx={{
						minWidth: 52,
						fontWeight: 700,
						// 停止を表す濃いグレーで「点灯」。ON の緑とは別色にする。
						...(!isOn
							? {
									bgcolor: 'text.secondary',
									color: 'background.paper',
									'&:hover': { bgcolor: 'text.primary' },
							  }
							: {}),
					}}
				>
					OFF
				</Button>
			)}
		</Box>
	)
}

export default BoolMachineToogleButton
